import React from 'react';
import i18n from 'i18n-js';
import Layout from 'components/Layout';
import { useParams } from 'react-router-dom';
import Grid from '@mui/material/Grid';
import Container from '@mui/material/Container';
import { legacyGridSafeContainerSx, legacyGridSafeItemSx } from 'theme/legacyGridInterop';
import Title from 'components/Title';
import { ReceivableDetails, ReceivableItems, ReceivableActions } from 'components/Receivable';
import Comments from 'components/Comments';
import Logs from 'components/Logs';
import Images from 'components/Images';

const BillingDetails = () => {
  const { id } = useParams();

  return (
    <Layout title={i18n.t('receivable.billing')}>
      <Container sx={{ minWidth: '100%', margin: 0 }}>
        <Grid container spacing={2} sx={legacyGridSafeContainerSx}>
          <Grid size={12}>
            <Grid
              container
              spacing={2}
              sx={legacyGridSafeContainerSx}
              direction="row"
              alignItems="center"
              justifyContent="space-between"
            >
              <Grid>
                <Title title={i18n.t('receivable.billing_details', { id: id })} />
              </Grid>
              <ReceivableActions id={id} options={['preview', 'download']} />
            </Grid>
          </Grid>
          <Grid size={12}>
            <Grid container spacing={2} sx={legacyGridSafeContainerSx}>
              <Grid size={{ xs: 12, sm: 12, md: 4 }} sx={legacyGridSafeItemSx}>
                <Grid container spacing={2} sx={legacyGridSafeContainerSx}>
                  <Grid size={12}>
                    <ReceivableDetails
                      id={id}
                      statusHide
                      receivableInfo={['from', 'to', 'source', 'completed_on', 'modified_on']}
                    />
                  </Grid>
                  <Grid size={12}>
                    <Images
                      id={id}
                      title={i18n.t('common.images')}
                      sourceType="invoice"
                      noProfile
                    />
                  </Grid>
                </Grid>
              </Grid>
              <Grid size={{ xs: 12, sm: 12, md: 4 }} sx={legacyGridSafeItemSx}>
                <Grid container spacing={2} sx={legacyGridSafeContainerSx}>
                  <Grid size={12}>
                    <ReceivableItems id={id} resume={['quantity', 'total_invoiced']} />
                  </Grid>
                </Grid>
              </Grid>
              <Grid size={{ xs: 12, sm: 12, md: 4 }} sx={legacyGridSafeItemSx}>
                <Grid container spacing={2} sx={legacyGridSafeContainerSx}>
                  <Grid size={12}>
                    <Comments type="invoice" id={+id} />
                  </Grid>
                  <Grid size={12}>
                    <Logs
                      targetId={parseInt(id)}
                      targetType="Invoice"
                      title={i18n.t('receivable.billing_logs')}
                      height={439}
                    />
                  </Grid>
                </Grid>
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      </Container>
    </Layout>
  );
};

export default BillingDetails;
